// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7031) return "static/chunks/796e604e-6339485541f8a5ff.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6832":"060c95f4b193c2a7","9582":"fbc71510893e5930"}[chunkId] + ".js";
};